export default {
	TransferInvs: function(state) {
		return state.TransferInvList;
	},
	TotalTransferTax: function(state) {
		return state.Total;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	}
};
